export default __webpack_public_path__ + "9dc4935f23f5a952b9c7eb8801cfc10c.svg";